<template>
  <div id="slider_courses">
    <b-carousel id="carousel-1" :interval="5000" background="##f5f5f5" img-width="1024" img-height="480">
      <b-carousel-slide v-for="(course, index) in $store.state.list_courses" :key="index" caption="" img-blank img-alt="Blank image">
        <div class="inner_slide_course">
          <div class="flyer_container">
            <img v-if="course.url_flyer" class="flyer" :src="'https://sportips.fr/challenge-maritima/img/flyer/' + course.url_flyer" alt="" />
          </div>

          <div class="infos_container">
            <p class="course_name">{{ course.name }}</p>
            <p class="course_date">
              {{ course.date }}
              <a :href="'/challenge-maritima/courses/#' + course.anchor"
                ><b-button class="infos_btn"><b-icon icon="info-circle-fill"></b-icon></b-button
              ></a>
            </p>
          </div>
        </div>
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>
<style>
.flyer_container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: end;
}
.flyer {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>